import styled, { css } from 'styled-components';
import { mediaQueries } from '../../providers/MediaQueryProvider';
export const InputsWrapper = styled.div `
  position: relative;
`;
export const InputsContainer = styled.div `
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  color: var(--text-secondary);
  pointer-events: none;

  ${({ $withRightIcon }) => $withRightIcon &&
    css `
      padding-right: var(--space-1000);
    `}
`;
export const CloseIconContainer = styled.div `
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  right: 0;
  top: 0;
  bottom: 0;
  padding: 0 var(--space-300);
  color: var(--icon-secondary);

  &:hover,
  &:active {
    color: var(--icon-primary);
  }
`;
export const CalendarContainer = styled.div `
  width: 100%;
  background: var(--bg-primary);
  display: flex;
  justify-content: center;
  align-items: flex-start;

  ${mediaQueries.tablet} {
    width: auto;
    display: inline;
    min-height: 0;
  }
`;
export const CalendarFooter = styled.div `
  display: flex;
  gap: var(--space-200);
  justify-content: flex-end;
`;
